var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InnerCardInfo',{ref:"inner",attrs:{"label":_vm.localStorage.translations.pages.finance.pages.salary,"data":[
    {
      name: _vm.translation['salary_hourly'],
      value: _vm.$formatCurrency(_vm.data.salary) + ' ' + _vm.translation['euro_hour'] || '- ' + _vm.translation['euro_hour'],
    },
    {
      name: _vm.translation['personal_premium'],
      value: _vm.$formatCurrency(_vm.data.premium) + ' ' + _vm.translation['euro_hour'] || '- ' + _vm.translation['euro_hour'],
    },
  ],"to":_vm.to,"button-icon":"show","editReady":_vm.editReady}},[_c('template',{slot:"edit_block"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }